import React, { PropTypes } from 'react';

import PageComponent from 'components/Page/_PageComponent';

const Page = ({ data, style }) => {
  let wrapper = false;
  const result = [];

  data.forEach((component, i) => {
    if (component.type.startsWith('wrapper')) {
      wrapper = component;
      wrapper.children = [];
    } else if (wrapper && component.type === 'end_wrapper') {
      result.push(
        <PageComponent key={wrapper.type + i} {...wrapper} />
      );
      wrapper = false;
    } else if (wrapper) {
      wrapper.children.push(
        <PageComponent key={component.type + i} {...component} />
      );
    } else {
      result.push(
        <PageComponent key={component.type + i} {...component} />
      );
    }
  });

  return (
    <div style={style}>
      {result}
    </div>
  );
};

Page.propTypes = {
  data: PropTypes.array
};



export default Page;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/Page.js
 **/